import React from 'react';

import Name from './Name.jsx';
import Utilities from './Utilities.jsx';

const statusIndicatorColor = /^(#([0-9a-f]{3}|[0-9a-f]{6}|[0-9a-f]{8})|[a-z]+|rgba?\(\s*\d{1,3}\s*(,\s*\d{1,3}\s*){2}(,\s*(0|1|0?\.\d+)\s*)?\)|hsla?\(\s*\d{1,3}\s*(,\s*\d{1,3}%?\s*){2}(,\s*(0|1|0?\.\d+)\s*)?\))$/i;
const statusIndicatorSize = /^\d+(\.\d+)?(px|pt|em|rem|%)$/;

const Token = {
    Address: {
        City: 'CITY',
        Country: 'COUNTRY',
        Line1: 'ADDRESS_LINE1',
        Line2: 'ADDRESS_LINE2',
        Location: 'LOCATION',
        Name: 'ADDRESS_NAME',
        State: 'STATE',
        Zip: 'ZIP'
    },
    Artist: {
        Biography: 'ARTIST_BIOGRAPHY',
        Birthdate: 'BIRTHDATE',
        CurriculumVitae: 'ARTIST_CURRICULUM_VITAE',
        Deathdate: 'DEATHDATE',
        Lifespan: 'ARTIST_LIFESPAN',
        Name: 'ARTIST_NAME'
    },
    CompanyName: 'COMPANY_NAME',
    Date: 'DATE',
    Discount: 'DISCOUNT',
    DisplayCurrency: {
        Amount: 'DISPLAY_CURRENCY_AMOUNT',
        Balance: 'DISPLAY_CURRENCY_BALANCE',
        Discount: 'DISPLAY_CURRENCY_DISCOUNT',
        GrandTotal: 'DISPLAY_CURRENCY_GRAND_TOTAL',
        Paid: 'DISPLAY_CURRENCY_PAID',
        Price: 'DISPLAY_CURRENCY_PRICE',
        PromoDiscount: 'DISPLAY_CURRENCY_PROMO_DISCOUNT',
        Refunded: 'DISPLAY_CURRENCY_REFUNDED',
        Shipping: 'DISPLAY_CURRENCY_SHIPPING',
        Subtotal: 'DISPLAY_CURRENCY_SUBTOTAL',
        SubtotalLessDiscount: 'DISPLAY_CURRENCY_SUBTOTAL_INCLUDE_DISCOUNT',
        TaxValue: 'DISPLAY_CURRENCY_TAX_VALUE'
    },
    Email: 'EMAIL',
    ExchangeCurrency: {
        Rate: [
            'AED', 'AFN', 'ALL', 'AMD', 'ANG', 'AOA', 'ARS', 'AUD', 'AWG', 'AZN',
            'BAM', 'BBD', 'BDT', 'BGN', 'BHD', 'BIF', 'BMD', 'BND', 'BOB', 'BOV',
            'BRL', 'BSD', 'BTN', 'BWP', 'BYN', 'BZD', 'CAD', 'CDF', 'CHE', 'CHF',
            'CHW', 'CLF', 'CLP', 'CNY', 'COP', 'COU', 'CRC', 'CUP', 'CVE', 'CZK',
            'DJF', 'DKK', 'DOP', 'DZD', 'EGP', 'ERN', 'ETB', 'EUR', 'FJD', 'FKP',
            'GBP', 'GEL', 'GHS', 'GIP', 'GMD', 'GNF', 'GTQ', 'GYD', 'HKD', 'HNL',
            'HTG', 'HUF', 'IDR', 'ILS', 'INR', 'IQD', 'IRR', 'ISK', 'JMD', 'JOD',
            'JPY', 'KES', 'KGS', 'KHR', 'KMF', 'KPW', 'KRW', 'KWD', 'KYD', 'KZT',
            'LAK', 'LBP', 'LKR', 'LRD', 'LSL', 'LYD', 'MAD', 'MDL', 'MGA', 'MKD',
            'MMK', 'MNT', 'MOP', 'MRU', 'MUR', 'MVR', 'MWK', 'MXN', 'MXV', 'MYR',
            'MZN', 'NAD', 'NGN', 'NIO', 'NOK', 'NPR', 'NZD', 'OMR', 'PAB', 'PEN',
            'PGK', 'PHP', 'PKR', 'PLN', 'PYG', 'QAR', 'RON', 'RSD', 'RUB', 'RWF',
            'SAR', 'SBD', 'SCR', 'SDG', 'SEK', 'SGD', 'SHP', 'SLE', 'SOS', 'SRD',
            'SSP', 'STN', 'SVC', 'SYP', 'SZL', 'THB', 'TJS', 'TMT', 'TND', 'TOP',
            'TRY', 'TTD', 'TWD', 'TZS', 'UAH', 'UGX', 'USD', 'USN', 'UYI', 'UYU',
            'UYW', 'UZS', 'VED', 'VES', 'VND', 'VUV', 'WST', 'XAF', 'XAG', 'XAU',
            'XBA', 'XBB', 'XBC', 'XBD', 'XCD', 'XDR', 'XOF', 'XPD', 'XPF', 'XPT',
            'XSU', 'XTS', 'XUA', 'XXX', 'YER', 'ZAR', 'ZMW', 'ZWG'
        ],

        value: (type) => Token.ExchangeCurrency.Rate.indexOf(type)
    },
    FooterText: 'FOOTER_TEXT',
    Group: 'GROUP',
    HeaderText: 'HEADER_TEXT',
    Inventory: {
        AcquisitionDate: 'ACQUISITION_DATE',
        AlternateDimensions: 'ALTERNATE_DIMENSIONS',
        AlternatePrices: 'ALTERNATE_PRICES',
        Cost: 'INVENTORY_COST',
        Dimensions: 'DIMENSIONS',
        DisplayPrice: 'DISPLAY_PRICE',
        Edition: 'EDITION',
        Framed: 'FRAMED',
        InsuranceValue: 'INSURANCE_VALUE',
        Location: 'LOCATION',
        Medium: 'MEDIUM',
        Number: 'INVENTORY_NUMBER',
        Price: 'PRICE',
        PriceWithTax: 'PRICE_WITH_TAX',
        Provenance: 'PROVENANCE',
        Quantity: 'QUANTITY',
        Signature: 'SIGNATURE',
        SKU: 'SKU',
        Sold: 'SOLD',
        StatusIndicator: 'STATUS_INDICATOR',
        Title: 'TITLE'
    },
    Invoice: {
        Number: 'INVOICE_NUMBER',
        Status: 'INVOICE_STATUS'
    },
    ListOrderNumber: 'LIST_ORDER_NUMBER',
    ListTitle: 'LIST_TITLE',
    Name: 'NAME',
    Notes: 'NOTES',
    ParagraphText: 'PARAGRAPH_TEXT',
    Payment: {
        Amount: 'AMOUNT',
        Method: 'METHOD'
    },
    Phone: {
        Default: 'PHONE',
        Home: 'PHONE_HOME',
        Mobile: 'PHONE_MOBILE',
        Other: 'PHONE_OTHER'
    },
    PurchaseOrderNumber: 'PURCHASE_ORDER_NUMBER',
    PrivateNotes: 'PRIVATE_NOTES',
    RecipientName: 'RECIPIENT_NAME',
    SenderName: 'SENDER_NAME',
    SpouseName: 'SPOUSE_NAME',
    Stage: 'STAGE',
    StaffName: 'STAFF_NAME',
    Statement: 'STATEMENT',
    TaxId: 'TAX_ID',
    Terms: 'TERMS',
    Title: 'TITLE',
    Total: {
        Balance: 'BALANCE',
        Consignment: 'CONSIGNMENT',
        GrandTotal: 'GRAND_TOTAL',
        Paid: 'PAID',
        PromoCode: {
            Code: 'PROMO_CODE',
            Description: 'DESCRIPTION',
            Discount: 'PROMO_DISCOUNT'
        },
        Refunded: 'REFUNDED',
        Retail: 'RETAIL',
        Shipping: 'SHIPPING',
        Subtotal: 'SUBTOTAL',
        SubtotalLessDiscount: 'SUBTOTAL_INCLUDE_DISCOUNT',
        Tax: {
            Name: 'TAX_NAME',
            Value: 'TAX_VALUE'
        }
    },
    TrackingNumber: 'TRACKING_NUMBER',
    Website: 'WEBSITE',

    _checkBlockForToken: (token, block, blockType) => {
        if (!block.type || block.type.value != blockType || !block.config) {
            return false;
        }
        const configNames = ['Block', 'Description', 'Label', 'Value'];
        for (let i = 0; i < configNames.length; i++) {
            if (!block.config[configNames[i]] || !block.config[configNames[i]].design) {
                continue;
            }
            const design = block.config[configNames[i]].design;
            if (design.indexOf(`token="${token}"`) >= 0 || design.indexOf(`token="${Token.Group}"`) >= 0 && design.indexOf(`{${token}(`) >= 0) {
                return true;
            }
        }
        return false;
    },
    _isTokenPresent: (token, blocks, blockType) => {
        let d;
        for (let i = 0; i < blocks.length; i++) {
            d = blocks[i];
            if (d.blocks) {
                for (let j = 0; j < d.blocks.length; j++) {
                    if (Token._isTokenPresent(token, d.blocks[j], blockType)) {
                        return true;
                    }
                }
            } else if (Token._checkBlockForToken(token, d, blockType)) {
                return true;
            }
        }
        return false;
    },

    cleanTokenValueForReplacement: (tokenValue) => {
        let cleanToken = tokenValue
            .replaceAll('<hr/>', '<hr>')
            .replaceAll('<hr>', '<span style="border-top: 1px solid #D1D1D1; display: block; margin: 8px 0;"></span>')
            .replaceAll('\n', '')
            .replaceAll('<div style="', '<span style="display: block;')
            .replaceAll('<div', '<span style="display: block;"')
            .replaceAll('</div>', '</span>');
        const headingTypes = [
            Name.Stylesheet.Paragraph,
            Name.Stylesheet.Header1,
            Name.Stylesheet.Header2,
            Name.Stylesheet.Header3,
            Name.Stylesheet.Header4
        ];
        headingTypes.forEach((d) => {
            cleanToken = cleanToken
                .replaceAll(`<${d} style="`, '<span style="display: block;')
                .replaceAll(`<${d}`, '<span style="display: block;"')
                .replaceAll(`</${d}>`, '</span>')
        });
        return cleanToken;
    },

    extractTokenOptions: (token, design) => {
        if (!design) {
            return;
        }
        let index = design.indexOf(`token="${token}"`);
        if (index < 0) {
            return;
        }
        let temp = `{${token}("`;
        index = design.indexOf(temp, index);
        if (index < 0) {
            return;
        }
        const end = design.indexOf('")}</span>', index);
        if (end < 0) {
            return;
        }
        const optionString = design.substring(index + temp.length, end);
        if (!optionString) {
            return;
        }
        const options = [];
        temp = optionString.split('","');
        temp.forEach(d => {
            const pairs = d.split('":"');
            if (pairs.length >= 2) {
                options[pairs[0]] = pairs[1];
            }
        });
        return options;
    },

    firstLineCurrencyDifferentToggleOption: { display: 'Format first line currency differently?', label: 'First Line Currency Format', name: 'formatFirst' },

    getAlternatePricesTokenConfig: () => {
        return {
            display: 'Alternate Prices',
            options: Token.ExchangeCurrency.Rate.map(d => Token.getAlternatePriceTokenConfig(d)),
            token: Token.Inventory.AlternatePrices
        }
    },

    getAlternatePriceTokenConfig: (value) => {
        return { ...Token.getWrappedTokenConfig(value, value), includeInTokenMap: true, name: value }
    },

    getEditionInfoTokenConfig: () => {
        return {
            display: 'Edition Info',
            options: [
                { defaultValue: Utilities.Inventory.getEditionFormatString('limited'), display: 'Limited Edition Display Format', name: 'limited', note: 'Keywords: [EditionNumber], [EditionCount]' },
                { defaultValue: Utilities.Inventory.getEditionFormatString('unlimited'), display: 'Unlimited Edition Display Format', name: 'unlimited', note: 'Keywords: [EditionNumber]' }
            ],
            token: Token.Inventory.Edition
        }
    },

    getCurrencyTokenConfig: (display, defaultValue, token, toggle) => {
        const options = [{ defaultValue, display: 'Currency Format', name: 'format', type: 'currencyFormat' }];
        if (toggle) {
            options.push({ defaultValue, name: toggle.name, toggle, type: 'currencyFormat' })
        }
        return { display, options, token }
    },

    getReplacementString: (value, options) => {
        let replaceString = '';
        if (value && value.toString().length > 0) {
            if (options && options.before) {
                replaceString += options.before;
            }
            replaceString += value;
            if (options && options.after) {
                replaceString += options.after;
            }
        }
        return replaceString;
    },

    getSoldTokenConfig: () => {
        return {
            display: 'Sold',
            options: [{ display: 'Display Text', name: 'display' }],
            token: Token.Inventory.Sold
        };
    },

    getStatusIndicatorTokenConfig: () => {
        return {
            display: 'Status Indicator',
            isObject: true,
            options: [
                { display: 'Sold Color', name: 'colorSold', type: 'color' },
                { display: 'Inactive Color', name: 'colorInactive', type: 'color' },
                { display: 'On Hold Color', name: 'colorHold', type: 'color' },
                { display: 'Size', name: 'size', type: 'measurement' }
            ],
            token: Token.Inventory.StatusIndicator
        };
    },

    getWrappedTokenConfig: (display, token) => {
        return {
            display,
            format: (data) => `${data.before || ''}{${data.token}}${data.after || ''}`,
            options: [
                { display: 'Prefix Label', name: 'before' },
                { display: 'Suffix Label', name: 'after' }
            ],
            token
        };
    },

    getDimensionsTokenConfig: (display, token) => {
        return {
            display,
            format: (data) => `${data.before || ''}{${data.token}}${data.after || ''}`,
            options: [
                { display: 'Prefix Label', name: 'before' },
                { display: 'Suffix Label', name: 'after' },
                { defaultValue: 'false', label: 'Use Fractional Dimensions', name: 'useFractional', type: 'toggle-small' }
            ],
            token
        };
    },

    isTokenPresent: (token, config, blockType) => {
        if (!config) {
            return false;
        }
        if (config.type == blockType) {
            return Token._isTokenPresent(token, [{ config, type: { value: blockType } }], blockType);
        }
        if (!config.Block || !config.Block.design) {
            return false;
        }
        if (config.Block.design.Config && config.Block.design.Config.blocks) {
            return Token._isTokenPresent(token, config.Block.design.Config.blocks, blockType);
        }
        return Token._isTokenPresent(token, [{ config, type: { value: blockType } }], blockType);
    },

    parseTokenizedString: (tokenizedString, handler) => {
        let parsedResultString = tokenizedString;
        let char, options;
        let indexStart = parsedResultString.indexOf('{');
        let indexEnd = indexStart;
        let keyword = '';
        let parsingList = false;
        let parsingOptions = false;
        let parsingString = false;
        while (indexStart >= 0 && indexEnd < parsedResultString.length - 1) {
            indexEnd += 1;
            char = parsedResultString.charAt(indexEnd);
            switch (char) {
                case '(':
                    if (parsingList || parsingOptions || parsingString) {
                        options += char;
                        break;
                    }
                    // Start options
                    options = '';
                    parsingOptions = true;
                    break;
                case ')':
                    if (parsingList || parsingString) {
                        options += char;
                        break;
                    }
                    // End options
                    parsingOptions = false;
                    break;
                case '[':
                    if (parsingOptions) {
                        parsingList = true;

                        // List components are converted to strings (wrapped in quotes) since they will be parsed separately
                        options += char;
                    }
                    break;
                case '"':
                    if (parsingList || parsingOptions) {
                        options += '"';
                        parsingString = !parsingString;
                    }
                    break;
                case ']':
                    if (parsingOptions) {
                        // List components are converted to strings (wrapped in quotes) since they will be parsed separately
                        options += char;
                    }
                    parsingList = false;
                    break;
                case '}':
                    if (parsingOptions) {
                        options += char;
                        break;
                    }
                    // End keyword
                    let parsedProps;
                    if (options) {
                        try { parsedProps = JSON.parse(`{${options}}`); } catch (e) { }
                    }
                    let replaceString;
                    switch (keyword) {
                        case Token.Inventory.AlternatePrices:
                        case Token.Group:
                            if (!parsedProps) {
                                break;
                            }
                            let parsedComponents = [];
                            if (parsedProps.components && parsedProps.components.length > 0) {
                                // Get replacement strings for each component in the group
                                parsedProps.components.forEach((d) => {
                                    if (!d) {
                                        return;
                                    }
                                    const string = d.replaceAll('"', '\\\"').replaceAll("*'", '"').trim();
                                    const parsedComponent = Token.parseTokenizedString(string, handler);
                                    if (parsedComponent === "") {
                                        return;
                                    }
                                    if (parsedComponent != undefined) {
                                        parsedComponents.push(parsedComponent);
                                    } else {
                                        parsedComponents.push(d);
                                    }
                                })
                            }
                            replaceString = Token.getReplacementString(parsedComponents.join(parsedProps.separator ? parsedProps.separator : ''), parsedProps);
                            break;
                        default:
                            if (handler) {
                                // Get the replacement string for the token keyword and props
                                replaceString = handler(keyword, parsedProps);
                            }
                    }
                    if (replaceString != undefined) {
                        // Replace the token with the replacement string
                        parsedResultString = parsedResultString.substring(0, indexStart) + replaceString + parsedResultString.substring(indexEnd + 1);

                        // Update end index to point to the end of the replacement string so parts of the string aren't skipped or processed twice
                        indexEnd = indexStart + replaceString.length;
                    }
                    keyword = '';
                    options = undefined;

                    // Find start of next keyword (if present)
                    indexStart = parsedResultString.indexOf('{', indexEnd);
                    indexEnd = indexStart;
                    break;
                default:
                    if (parsingOptions) {
                        options += char;
                    } else {
                        keyword += char;
                    }
                    break;
            }
        }
        return parsedResultString;
    },

    withContentTokenParsing: (WrappedComponent, { allowEmptyContent, contentTokenSourceHandler, extraParseConditionHandler }, tokenHandler) => {
        return function (props) {
            const [id, setId] = React.useState(undefined);
            React.useEffect(() => { setId(Utilities.generateUniqueId()) }, []);

            const parseContent = (props, tokenizedString) => {
                if (!tokenizedString || (!props.serverSide && !id)) {
                    return '';
                }
                const design = Token.parseTokenizedString(tokenizedString, (keyword, options) => tokenHandler ? tokenHandler(props, keyword, options) : '');
                if (allowEmptyContent != true && Utilities.isHTMLContentEmpty(design)) {
                    return '';
                }
                return design;
            }
            const [content, setContent] = React.useState(undefined);
            const updateContent = (props, tokenizedString) => {
                if (!id) {
                    return;
                }
                setContent(parseContent(props, tokenizedString))
            }
            const parseConditions = [id, props.config.config.Block.design, props.visibilityHash];
            if (extraParseConditionHandler) {
                parseConditions.push(...extraParseConditionHandler(props));
            }
            React.useEffect(() => updateContent(props, contentTokenSourceHandler ? contentTokenSourceHandler(props) : props.config.config.Block.design), parseConditions);

            if (props.serverSide && content == undefined) {
                setContent(parseContent(props, contentTokenSourceHandler ? contentTokenSourceHandler(props) : props.config.config.Block.design))
            }
            if (allowEmptyContent != true && !props.builder && content != undefined && content.length == 0) {
                return null;
            }
            return <WrappedComponent {...props} content={content} id={id} onParseContent={parseContent} onUpdateContent={updateContent}>{props.children}</WrappedComponent>
        }
    },

    TypeParsing: {
        artist: (props, keyword, options) => {
            let data = props.itemData || props.data || {};
            if (data.Artists && props.index < data.Artists.length) {
                data = data.Artists[props.index];
            }
            const visibility = props.visibility || {};
            if (!props.forceVisibility && !props.builder && visibility[keyword] == false) {
                return '';
            }
            let replaceString = '';
            switch (keyword) {
                case Token.Artist.Biography:
                    if (!Utilities.isNullOrWhitespace(data.About)) {
                        replaceString = Token.cleanTokenValueForReplacement(data.About);
                    }
                    if (!Utilities.isNullOrWhitespace(data.Bio)) {
                        replaceString = Token.cleanTokenValueForReplacement(data.Bio);
                    }
                    break;
                case Token.Artist.Birthdate:
                    if (!Utilities.isNullOrWhitespace(data.Birthdate)) {
                        replaceString = Token.getReplacementString(data.Birthdate, options);
                    }
                    break;
                case Token.Artist.CurriculumVitae:
                    if (!Utilities.isNullOrWhitespace(data.CurriculumVitae)) {
                        replaceString = Token.cleanTokenValueForReplacement(data.CurriculumVitae);
                    }
                    break;
                case Token.Artist.Deathdate:
                    if (!Utilities.isNullOrWhitespace(data.Deathdate)) {
                        replaceString = Token.getReplacementString(data.Deathdate, options);
                    }
                    break;
                case Token.Artist.Lifespan:
                    if (!Utilities.isNullOrWhitespace(data.Lifespan)) {
                        replaceString = Token.getReplacementString(data.Lifespan, options);
                    }
                    break;
                case Token.Artist.Name:
                    if (!Utilities.isNullOrWhitespace(data.Name)) {
                        replaceString = Token.getReplacementString(data.Name, options);
                    }
                    break;
            }
            return replaceString;
        },
        inventory: (props, keyword, options) => {
            let data = props.itemData || props.data || {};
            if (data.Inventory && props.index < data.Inventory.length) {
                data = data.Inventory[props.index];
            }
            let _keyword = keyword;
            let temp = Token.ExchangeCurrency.value(keyword);
            if (temp >= 0) {
                _keyword = Token.Inventory.AlternatePrices;
            }
            const visibility = props.visibility || {};
            if (!props.forceVisibility && !props.builder && visibility[_keyword] == false) {
                return '';
            }
            let replaceString = '';
            if (temp >= 0) {
                if (data.Prices) {
                    for (let i = 0; i < data.Prices.length; i++) {
                        if (data.Prices[i].Currency != temp) {
                            continue;
                        }
                        const value = data.Prices[i].Value;
                        if (!Utilities.isNullOrWhitespace(value)) {
                            replaceString = Token.getReplacementString(value, options);
                        }
                        break;
                    }
                }
                return replaceString;
            }
            temp = undefined;
            switch (keyword) {
                case Token.Artist.Biography:
                    if (data.Artist && !Utilities.isNullOrWhitespace(data.Artist.Bio)) {
                        replaceString = Token.cleanTokenValueForReplacement(data.Artist.Bio);
                    }
                    break;
                case Token.Artist.Lifespan:
                    if (data.Artist && !Utilities.isNullOrWhitespace(data.Artist.Lifespan)) {
                        replaceString = Token.getReplacementString(data.Artist.Lifespan, options);
                    }
                    break;
                case Token.Artist.Name:
                    if (!Utilities.isNullOrWhitespace(data.ArtistName)) {
                        replaceString = Token.getReplacementString(data.ArtistName, options);
                    } else if (data.Artist && !Utilities.isNullOrWhitespace(data.Artist.Name)) {
                        replaceString = Token.getReplacementString(data.Artist.Name, options);
                    }
                    break;
                case Token.Date:
                    if (!Utilities.isNullOrWhitespace(data.Date)) {
                        replaceString = Token.getReplacementString(data.Date, options);
                    }
                    break;
                case Token.Discount:
                    replaceString = `<span style="white-space:pre;">${Utilities.Format.getDiscountString(data, props.index, props.data && props.data.Gallery && props.data.Gallery.Localization, options)}</span>`;
                    break;
                case Token.DisplayCurrency.Discount:
                    if (data.Discount != 0 && data.DiscountType != 1 && data.ExchangeRate && data.ExchangeRate.Discount != undefined) {
                        replaceString = Token.getReplacementString(data.ExchangeRate.Discount, options);
                    }
                    break;
                case Token.DisplayCurrency.Price:
                    if (!props.builder && options.noDiscount == 'false' && data.Discount == 0) {
                        break;
                    }
                    if (data.ExchangeRate && !Utilities.isNullOrWhitespace(data.ExchangeRate.Price)) {
                        replaceString = Token.getReplacementString(data.ExchangeRate.Price, options);
                    }
                    break;
                case Token.DisplayCurrency.Subtotal:
                    if (data.ExchangeRate && !Utilities.isNullOrWhitespace(data.ExchangeRate.Subtotal)) {
                        replaceString = Token.getReplacementString(data.ExchangeRate.Subtotal, options);
                    }
                    break;
                case Token.Inventory.AcquisitionDate:
                    if (!Utilities.isNullOrWhitespace(data.AcquiredAt)) {
                        replaceString = Token.getReplacementString(data.AcquiredAt, options);
                    }
                    break;
                case Token.Inventory.AlternateDimensions: {
                    const alternateValue = (options && options.useFractional === 'true' && !Utilities.isNullOrWhitespace(data.AlternateDimensionsFractional))
                        ? data.AlternateDimensionsFractional
                        : data.AlternateDimensions;
                    if (!Utilities.isNullOrWhitespace(alternateValue)) {
                        replaceString = Token.getReplacementString(alternateValue, options);
                    }
                    break;
                }
                case Token.Inventory.Dimensions: {
                    const dimensionsValue = (options && options.useFractional === 'true' && !Utilities.isNullOrWhitespace(data.DimensionsFractional))
                        ? data.DimensionsFractional
                        : data.Dimensions;
                    if (!Utilities.isNullOrWhitespace(dimensionsValue)) {
                        replaceString = Token.getReplacementString(dimensionsValue, options);
                    }
                    break;
                }
                case Token.Inventory.DisplayPrice:
                    if (!Utilities.isNullOrWhitespace(data.PriceOverride)) {
                        replaceString = Token.getReplacementString(data.PriceOverride, options);
                    }
                    break;
                case Token.Inventory.Edition:
                    let editionInfo;
                    if (props.collateralConfig) {
                        let configType = props.configType || props.collateralConfig.Type;
                        switch (configType) {
                            case Name.Config.Tearsheet:
                            case Name.Content.CertificateItem:
                            case Name.Content.MosaicItem:
                            case Name.Content.PricelistInventoryItem:
                            case Name.Content.TearsheetItem:
                                const formatLimited = options?.limited || Utilities.Inventory.getEditionFormatString('limited');
                                const formatUnlimited = options?.unlimited || Utilities.Inventory.getEditionFormatString('unlimited');
                                editionInfo = Utilities.Inventory.getEditionNumberWithFormat(data, formatLimited, formatUnlimited);
                                break;
                        }
                    }
                    if (!editionInfo) {
                        editionInfo = Utilities.Inventory.getEditionNumber(data);
                    }
                    if (!Utilities.isNullOrWhitespace(editionInfo)) {
                        replaceString = Token.getReplacementString(editionInfo, options);
                    }
                    break;
                case Token.Inventory.Framed:
                    if (!Utilities.isNullOrWhitespace(data.Framed)) {
                        replaceString = Token.getReplacementString(data.Framed, options);
                    }
                    break;
                case Token.Inventory.InsuranceValue:
                    if (!Utilities.isNullOrWhitespace(data.InsuranceValue)) {
                        let format;
                        if (options) {
                            format = options.format;
                        }
                        replaceString = `<span style="white-space:pre;">${Utilities.Format.Currency.getDisplayString(data.InsuranceValue, format, props.data && props.data.Gallery && props.data.Gallery.Localization)}</span>`;
                    }
                    break;
                case Token.Inventory.Location:
                    if (!Utilities.isNullOrWhitespace(data.Location)) {
                        replaceString = Token.getReplacementString(data.Location, options);
                    }
                    break;
                case Token.Inventory.Medium:
                    if (!Utilities.isNullOrWhitespace(data.Medium)) {
                        replaceString = Token.getReplacementString(data.Medium, options);
                    }
                    break;
                case Token.Inventory.Number:
                    if (!Utilities.isNullOrWhitespace(data.Number)) {
                        replaceString = Token.getReplacementString(data.Number, options);
                    }
                    break;
                case Token.ListOrderNumber:
                    if (props.index != undefined) {
                        replaceString = Token.getReplacementString(`${props.index + 1}`, options);
                    }
                    break;
                case Token.Inventory.Cost:
                    if (!Utilities.isNullOrWhitespace(data.Cost)) {
                        let format;
                        if (options) {
                            format = options.format;
                        }
                        replaceString = `<span style="white-space:pre;">${Utilities.Format.Currency.getDisplayString(data.Cost, format, props.data && props.data.Gallery && props.data.Gallery.Localization)}</span>`;
                    }
                    break;
                case Token.Inventory.Price:
                    temp = temp || data.Price;
                // Intentional fallthrough
                case Token.Total.Consignment:
                    temp = temp || data.Consignment;
                // Intentional fallthrough
                case Token.Total.Retail:
                    temp = temp || data.Retail;
                    if (!Utilities.isNullOrWhitespace(temp)) {
                        let format;
                        if (options) {
                            if (!props.builder && options.noDiscount == 'false' && data.Discount == 0) {
                                break;
                            }
                            format = options.format;
                            if (props.index == 0 && options.formatFirst && options.formatFirst.length > 0) {
                                format = options.formatFirst;
                            }
                        }
                        replaceString = `<span style="white-space:pre;">${Utilities.Format.Currency.getDisplayString(temp, format, props.data && props.data.Gallery && props.data.Gallery.Localization)}</span>`;
                    }
                    break;
                case Token.Inventory.PriceWithTax:
                    if (!Utilities.isNullOrWhitespace(data.PriceWithTax)) {
                        let format;
                        if (options) {
                            format = options.format;
                            if (props.index == 0 && options.formatFirst && options.formatFirst.length > 0) {
                                format = options.formatFirst;
                            }
                        }
                        replaceString = `<span style="white-space:pre;">${Utilities.Format.Currency.getDisplayString(data.PriceWithTax, format, props.data && props.data.Gallery && props.data.Gallery.Localization)}</span>`;
                    }
                    break;
                case Token.Inventory.Quantity:
                    if (!Utilities.isNullOrWhitespace(data.Quantity)) {
                        replaceString = Token.getReplacementString(data.Quantity, options);
                    }
                    break;
                case Token.Inventory.Signature:
                    if (!Utilities.isNullOrWhitespace(data.Signature)) {
                        replaceString = Token.getReplacementString(data.Signature, options);
                    }
                    break;
                case Token.Inventory.SKU:
                    if (!Utilities.isNullOrWhitespace(data.SKU)) {
                        replaceString = Token.getReplacementString(data.SKU, options);
                    }
                    break;
                case Token.Inventory.Sold:
                    if (data.IsSold && !Utilities.isNullOrWhitespace(options?.display)) {
                        replaceString = options.display;
                    }
                    break;
                case Token.Inventory.StatusIndicator: {
                    let colorKey, defaultColor;
                    if (data.IsSold) {
                        colorKey = 'colorSold';
                        defaultColor = '#ED5757';
                    } else if (data.IsOnHold) {
                        colorKey = 'colorHold';
                        defaultColor = '#FFC107';
                    } else if (data.IsActive === false) {
                        colorKey = 'colorInactive';
                        defaultColor = '#414141';
                    }
                    if (colorKey) {
                        const color = statusIndicatorColor.test(options?.[colorKey]?.trim() ?? '') ? options[colorKey].trim() : defaultColor;
                        const size = statusIndicatorSize.test(options?.size?.trim() ?? '') ? options.size.trim() : '10px';
                        replaceString = `<i style="display:inline-block;width:${size};height:${size};border-radius:50%;background-color:${color};vertical-align:middle;margin-right:5px;"></i>`;
                    }
                    break;
                }
                case Token.Inventory.Title:
                    if (!Utilities.isNullOrWhitespace(data.Title)) {
                        replaceString = Token.getReplacementString(data.Title, options);
                    }
                    break;
                case Token.Notes:
                    if (!Utilities.isNullOrWhitespace(data.Notes)) {
                        replaceString = Token.getReplacementString(Token.cleanTokenValueForReplacement(data.Notes.replaceAll('\n', '<br/>')), options);
                    }
                    break;
                case Token.Inventory.Provenance:
                    if (!Utilities.isNullOrWhitespace(data.Provenance)) {
                        replaceString = Token.getReplacementString(Token.cleanTokenValueForReplacement(data.Provenance.replaceAll('\n', '<br/>')), options);
                    }
                    break;
                case Token.PrivateNotes:
                    if (!Utilities.isNullOrWhitespace(data.PrivateNotes)) {
                        replaceString = Token.getReplacementString(data.PrivateNotes.replaceAll('\n', '<br/>'), options);
                    }
                    break;
                case Token.Total.Subtotal:
                    if (data.Subtotal == 0 || !Utilities.isNullOrWhitespace(data.Subtotal)) {
                        let format;
                        if (options) {
                            format = options.format;
                            if (props.index == 0 && options.formatFirst && options.formatFirst.length > 0) {
                                format = options.formatFirst;
                            }
                        }
                        replaceString = `<span style="white-space:pre;">${Utilities.Format.Currency.getDisplayString(data.Subtotal, format, props.data && props.data.Gallery && props.data.Gallery.Localization)}</span>`;
                    }
                    break;
                default:
                    replaceString = undefined;
                    break;
            }
            return replaceString;
        }
    }
}

export default Token;